import React from 'react'

interface ImpactListProps {
  intro: React.ReactNode
  items: string[]
  emptyText?: string
  className?: string
}

const ImpactList = ({
  intro,
  items,
  emptyText,
  className
}: ImpactListProps) => (
  <>
    <p>{intro}</p>
    <ul className={className}>
      {items.length === 0 ? (
        <li>{emptyText}</li>
      ) : (
        items.map((item) => <li key={item}>{item}</li>)
      )}
    </ul>
  </>
)

export default ImpactList
